module.exports = __webpack_public_path__ + "img/book-open-reader.ef00b73e.svg";